<template>
  <ModalComponent :visible="show" @close="$emit('close')">
    <template #title>
      <div class="ps-5 h2 mb-0 d-flex align-items-center gap-2">
        <template v-if="!selectedEvent.type">
          {{ $t('Undefined') }}
        </template>
        <template v-else>
          {{ $t('enums/concierge_appointment_types.' + selectedEvent.type) }}
        </template>
      </div>
    </template>
    <template #title-end>
      <div class="ml-auto">
        <Popper
          v-if="leadService"
          :content="$t('models/conciergeAppointments.lead.tooltip', { service: leadService })"
          class="popper--light"
          placement="left"
          arrow
          hover
        >
          <a
            v-if="leadUrl"
            :href="leadUrl"
            target="_blank"
            class="text-white pr-2 d-block"
            style="transform: translateY(3px)"
          >
            <i class="fa-kit-duotone fa-activix" style="font-size: 1.3rem !important"></i>
          </a>
        </Popper>
      </div>
    </template>
    <template #body>
      <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <strong>{{ $t('services/concierge_dashboard.appointment_status') }}</strong>
          <div class="d-inline">
            <span :class="statusColor" class="badge badge-pill">
              {{ $t('enums/concierge_appointment_status.status.' + selectedEvent.status) }}
            </span>
          </div>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <strong>{{ $t('services/concierge_dashboard.date_time') }}</strong>
          <span> {{ selectedEvent.formattedDate }}</span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <strong>{{ $t('services/concierge_dashboard.client') }}</strong>
          <span> {{ selectedEvent.customer }}</span>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center">
          <strong>{{ $t('services/concierge_dashboard.adviser') }}</strong>
          <span> {{ selectedEvent.adviser }}</span>
        </li>
        <li
          v-if="selectedEvent.isTestDrive || selectedEvent.vehicleNames.length > 0"
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          <strong>{{ $t('services/concierge_dashboard.vehicles') }}</strong>
          <span> {{ selectedEvent.vehicleNames }}</span>
        </li>
      </ul>
    </template>
    <template #submit>
      <a
        v-if="$can('edit concierge appointments')"
        :href="selectedEvent.endpoints.appointment"
        class="btn btn-primary"
        >{{ $t('crud.update') }}</a
      >
    </template>
  </ModalComponent>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ModalComponent from '@components/modals/ModalComponent.vue'

export default defineComponent({
  name: 'CalendarEventModal',
  components: { ModalComponent },
  emits: ['close'],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedEvent: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    statusColor() {
      const colors = new Map([
        ['scheduled', 'bg-primary'],
        ['canceled', 'bg-warning'],
        ['done', 'bg-success'],
        ['no_show', 'bg-danger']
      ])
      return this.selectedEvent?.status && colors.has(this.selectedEvent.status)
        ? colors.get(this.selectedEvent.status)
        : 'bg-secondary'
    },
    lead(): Record<string, string> | null {
      return this.selectedEvent?.lead || null
    },
    leadService(): string {
      return this.lead?.['service'] || ''
    },
    leadUrl(): string {
      return this.lead?.['url'] || ''
    }
  }
})
</script>
<style lang="scss" scoped>
.fc .fc-popover {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 6px;
  position: absolute;
  z-index: 9998;
}

.modal-window-wrapper > .modal {
  z-index: 9999;
}

:deep(.modal-window-overlay > div) {
  /* ... */
  z-index: 9999;
}
</style>
